import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import { MdOutlineWork } from "react-icons/md";
import { IoIosSchool } from "react-icons/io";
import { FaStar } from "react-icons/fa";

const timelineContainer = {
  height: '100vh',
  'overflow-y': 'auto',
  // 'background-color': 'rgba(3, 3, 3, 0.12)',
  'padding-top': '1rem',
  'padding-bottom': '5rem',

};

const Timeline = () => {
  return (
    <div className="timeline-container" style={timelineContainer}>

      <VerticalTimeline>
        <VerticalTimelineElement
          className="vertical-timeline-element--work current-exp"
          contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
          date="SEP 2021 - PRESENT"
          iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          icon={<MdOutlineWork />}
        >
          <h3 className="vertical-timeline-element-title">Web Developer</h3>
          <h4 className="vertical-timeline-element-subtitle">ZMQ Development</h4>
          <p>
            ●  <div>Developed and designed web applications and RESTful APIs using React.js, HTML5, CSS3, PHP, and Codeigniter, handling both frontend and backend tasks like creating responsive pages, API services, and bug fixing.</div>
            ●  <div>Gained experience in debugging, testing, deploying applications on live servers, using Git & GitHub for version control, and collaborating with teams.</div>
            ●  <div>Represented ZMQ Development in Uganda to train the Ministry of Health on the ‘Uganda DAT TB Platform,’ ensuring successful system implementation and user proficiency.</div>
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work past-exp"
          date="APR 2021 - AUG 2021"
          iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          icon={<MdOutlineWork />}
        >
          <h3 className="vertical-timeline-element-title">Web Developer - Trainee</h3>
          <h4 className="vertical-timeline-element-subtitle">ZMQ Development</h4>
          <p>
            ● <div> During  internship  I  developed  and  designed  a  web  application  to  manage  data
              of DS TB patients.</div>
            ● <div> Worked on both the frontend and backend part.</div>
            ● <div> Got the opportunity to learn about the RESTful API, MVC Pattern, Git and Github.</div>
          </p>
        </VerticalTimelineElement>
        {/* <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2008 - 2010"
          iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          icon={<MdOutlineWork />}
        >
          <h3 className="vertical-timeline-element-title">Web Designer</h3>
          <h4 className="vertical-timeline-element-subtitle">Los Angeles, CA</h4>
          <p>
            User Experience, Visual Design
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2006 - 2008"
          iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          icon={<MdOutlineWork />}
        >
          <h3 className="vertical-timeline-element-title">Web Designer</h3>
          <h4 className="vertical-timeline-element-subtitle">San Francisco, CA</h4>
          <p>
            User Experience, Visual Design
          </p>
        </VerticalTimelineElement> */}
        <VerticalTimelineElement
          className="vertical-timeline-element--education past-exp"
          date="JUL 2018 - JUL 2021"
          iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
          icon={<IoIosSchool />}
        >
          <h3 className="vertical-timeline-element-title">Master Of Computer Applications</h3>
          <h4 className="vertical-timeline-element-subtitle">Aligarh Muslim University</h4>
          <p>
            Aligarh
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--education past-exp"
          date="MAY 2015 - MAY 2018"
          iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
          icon={<IoIosSchool />}
        >
          <h3 className="vertical-timeline-element-title">Bachelor of Science in Information Technology </h3>
          <h4 className="vertical-timeline-element-subtitle">Gossner College Ranchi</h4>
          <p>
            Ranchi
          </p>
        </VerticalTimelineElement>
        {/* <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="2002 - 2006"
          iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
          icon={<IoIosSchool />}
        >
          <h3 className="vertical-timeline-element-title">Bachelor of Science in Interactive Digital Media Visual Imaging</h3>
          <h4 className="vertical-timeline-element-subtitle">Bachelor Degree</h4>
          <p>
            Creative Direction, Visual Design
          </p>
        </VerticalTimelineElement> */}
        <VerticalTimelineElement
          iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
          icon={<FaStar />}
        />
      </VerticalTimeline>

    </div>
  );
}

export default Timeline;